var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}]},[_c('contract-detail-history-list',{attrs:{"reverse":_vm.reverse,"type":"Normal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }